// ── Shared helper functions for the metrics feature ──────────────────────────

export function fmt90DayParams() {
  const pad = (n: number) => String(n).padStart(2, '0')
  const fmt = (d: Date) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00:00`
  const now = new Date()
  const past = new Date(now)
  past.setDate(past.getDate() - 90)
  return { from: fmt(past), to: fmt(now) }
}

export function dateToApi(dateStr: string, endOfDay: boolean) {
  return endOfDay ? `${dateStr}T23:59:59Z` : `${dateStr}T00:00:00Z`
}

export function todayStr() {
  return new Date().toISOString().slice(0, 10)
}

export function nDaysAgoStr(n: number) {
  const d = new Date()
  d.setDate(d.getDate() - n)
  return d.toISOString().slice(0, 10)
}

export function stageLabel(s: string) {
  return s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

export function targetLabel(s: string) {
  return s.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}
